<template>
  <div
    style="background: #fff; padding: 20px; display: flex; justify-content: space-between"
  >
    <a-space>
      <span>站点:</span>
      <a-select
        style="width: 200px"
        v-model:value="state.uniqueId"
        @change="state.onUniqueIdChange"
      >
        <a-select-option
          v-for="item in state.siteDataList"
          :key="item.uniqueId"
          :value="item.uniqueId"
        >
          {{ item.uniqueName }}
        </a-select-option>
      </a-select>
    </a-space>
    <a-space>
      <a-button type="primary" @click="state.visible = true">
        总频次控制
      </a-button>
      <a-button type="primary">
        <router-link
          :to="{
            path: '/PopupRuleDetail',
            query: { uniqueId: state.uniqueId }
          }"
        >
          创建规则
        </router-link>
      </a-button>
    </a-space>
  </div>
  <div style="margin-top: 20px; background: #fff; padding: 20px;">
    <div
      style="margin-bottom: 20px; display: flex; justify-content: space-between"
    >
      <a-space>
        <a-space>
          <span>规则ID</span>
          <a-input
            v-model:value="state.search.id"
            placeholder="请输入规则ID"
          ></a-input>
        </a-space>
        <a-space>
          <span>规则名称</span>
          <a-input
            v-model:value="state.search.name"
            placeholder="请输入规则名称"
          ></a-input>
        </a-space>
        <a-space>
          <span>状态</span>
          <a-select
            v-model:value="state.search.enable"
            placeholder="请选择状态"
            style="width: 150px;"
          >
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">停用</a-select-option>
          </a-select>
        </a-space>
        <a-space>
          <span>弹窗类型</span>
          <a-select
            v-model:value="state.search.type"
            placeholder="请选择弹窗类型"
            style="width: 150px;"
          >
            <a-select-option
              v-for="item in state.popupTypeList"
              :value="item.type"
              :key="item.type"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-space>
      </a-space>
      <a-space>
        <a-button type="primary" @click="state.initList(1)">查询</a-button>
        <a-button @click="state.reset">重置</a-button>
      </a-space>
    </div>
    <a-table
      :columns="state.columns"
      rowKey="id"
      :dataSource="state.dataSource"
      bordered
      :pagination="false"
      :rowSelection="{
        hideSelectAll: true,
        selectedRowKeys: state.selectedRowKeys,
        onChange: state.onSelectChange,
        preserveSelectedRowKeys: true
      }"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          {{ state.popupTypeList.find(i => i.type === record.type)?.name }}
        </template>
        <template v-if="column.key === 'enable'">
          {{ record.enable === 1 ? '启用' : '停用' }}
        </template>
        <template v-if="column.key === 'action'">
          <a-button
            type="link"
            @click="
              $router.push({
                path: '/PopupRuleDetail',
                query: { uniqueId: state.uniqueId, id: record.id }
              })
            "
          >
            编辑
          </a-button>
          <a-button type="link" @click="state.onToggleStatus(record)">
            {{ record.enable === 1 ? '停用' : '启用' }}
          </a-button>
          <a-popconfirm title="确认删除?" @confirm="state.onDelete(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm>
        </template>
      </template>
    </a-table>
    <Pagination />
  </div>
  <Modal />
</template>

<script setup>
import { reactive, onMounted, provide } from 'vue'
import Pagination from './components/Pagination/index.vue'
import Modal from './components/Modal.vue'
import { site_list_get } from '@/server/modules/635'
import {
  popupWindow_rule_page,
  popupWindow_rule_enable,
  popupWindow_rule_delete,
  popupWindow_base_popupTypeList,
  popupWindow_main_add
} from '@/server/modules/51648'
import { usePagination } from '@/utils/useCommon'
import { message } from 'ant-design-vue'
import { useRoute } from 'vue-router'

const { uniqueId, siteId, terminalId } = useRoute().query

const state = reactive({
  pagination: usePagination(),
  siteDataList: [],
  uniqueId: uniqueId ? Number(uniqueId) : 1,
  siteId: siteId ? Number(siteId) : 1,
  terminalId: terminalId ? Number(terminalId) : 1,
  visible: false,
  popupTypeList: [],
  selectedRowKeys: [],
  search: {
    id: '',
    name: '',
    enable: undefined,
    type: undefined
  },
  dataSource: [],
  columns: [
    {
      title: '规则ID',
      dataIndex: 'id',
      align: 'center'
    },
    {
      title: '规则名称',
      dataIndex: 'name',
      align: 'center',
      ellipsis: true
    },
    {
      title: '弹窗类型',
      dataIndex: 'type',
      key: 'type',
      align: 'center'
    },
    {
      title: '创建人',
      dataIndex: 'creatorUserName',
      align: 'center'
    },
    {
      title: '创建时间',
      dataIndex: 'gmtCreate',
      align: 'center'
    },
    {
      title: '生效时间',
      dataIndex: 'startDatetime',
      align: 'center'
    },
    {
      title: '状态',
      dataIndex: 'enable',
      key: 'enable',
      align: 'center'
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 240
    }
  ],
  onSelectChange: selectedRowKeys => {
    state.selectedRowKeys = selectedRowKeys
  },
  onUniqueIdChange: value => {
    const item = state.siteDataList.find(i => i.uniqueId === value)
    state.siteId = item.siteId
    state.terminalId = item.terminalId
    state.initList(1)
    getPopupTypeList()
  },
  initList: async (pageNum, pageSize) => {
    if (pageNum) {
      state.pagination.pageNum = pageNum
    }
    if (pageSize) {
      state.pagination.pageSize = pageSize
    }
    const params = {
      ...state.search,
      ...state.pagination,
      brandId: 1,
      channelId: 1,
      siteId: state.siteId,
      terminalId: state.terminalId
    }
    const { data } = await popupWindow_rule_page(params)
    state.dataSource = data.list
    state.pagination.total = data.total
  },
  reset: () => {
    state.search = {
      id: '',
      name: '',
      enable: undefined,
      type: undefined
    }
    state.initList(1)
  },
  onOk: async data => {
    if (state.selectedRowKeys.length < 2) {
      return message.warn('至少需要勾选2个规则')
    }
    const params = {
      brandId: 1,
      channelId: 1,
      siteId: state.siteId,
      terminalId: state.terminalId,
      ruleIdList: state.selectedRowKeys,
      ...data
    }
    const { success, retInfo } = await popupWindow_main_add(params)
    if (success) {
      state.visible = false
      message.success('添加成功')
    } else {
      message.error(retInfo)
    }
  },
  onToggleStatus: async record => {
    const param = {
      id: record.id,
      enable: record.enable === 1 ? 0 : 1
    }
    await popupWindow_rule_enable(param)
    message.success(param.enable === 1 ? '启用成功' : '禁用成功')
    state.initList(1)
  },
  onDelete: async record => {
    const params = {
      id: record.id
    }
    await popupWindow_rule_delete(params)
    message.success('删除成功')
    state.initList(1)
    state.selectedRowKeys = state.selectedRowKeys.filter(i => i !== record.id)
  }
})

provide('initState', state)

const getSiteData = async () => {
  const { data } = await site_list_get()
  state.siteDataList = data
}

const getPopupTypeList = async () => {
  const params = {
    brandId: 1,
    channelId: 1,
    siteId: state.siteId,
    terminalId: state.terminalId
  }
  const { data } = await popupWindow_base_popupTypeList(params)
  state.popupTypeList = data
}

onMounted(async () => {
  await getSiteData()
  await getPopupTypeList()
  await state.initList()
})
</script>
